// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__3kBrS","inputWrap":"CustomTip_inputWrap__1IJSS"};